//Esta função cria um header a partir do getState
const attachTokenToHeaders = (getState, headers = {}) => {    
    const options = {
      headers: headers
    };
    const token = getState().auth.token;
    if (token) {
      options.headers['Authorization'] = `bearer ${token}`;
    }  
    return options;
};


//Esta função altera as keys da Api de acordo com o objeto mapping
  //A Api retorna seus nomes (object keys) em snake_case, é possível utilizar essa função para converter os nomes para camelCase
const mapApiData = (data, mapping) => {
    
  let mapped = Object.keys(data).reduce((acc, key) => {

    if(mapping[key]){
      acc[mapping[key]] = data[key];
    } 
    
    return acc;

  }, {});

  return mapped;

}


//Esta função é semelhante a mapApiData para utilizar quando a response é uma array de objetos, em vez de um objeto
const mapApiDataArray = (dataArray, mapping) => {

  let mapped = [];

  for (var i = 0; i < dataArray.length; i++) {
    mapped[i] = mapApiData(dataArray[i], mapping)
  }

  return mapped;

}

async function handleErrorForAllActions(err, getState) {
  console.log('handleErrorForAllActions called with error:', err?.response?.status);
  switch (err?.response?.status) {
    case 401: 
        console.log('Error 401 detected, proceeding directly to login...');
        // Simplificar: si recibimos un 401, directamente proceder con el login
        atualizarPaginaParaForcarNovoLogin();
      break;
    default:
      break;
  }
  return false;
}

/*
async function verificarSeTokenExpirou(getState){
  console.log('verificarSeTokenExpirou called');
  try {
    const options = attachTokenToHeaders(getState, {'Accept': 'application/json'});
    console.log('Making request to /auth/me with options:', options);
    await axios.get('/auth/me', options);
    console.log('Token verification successful - token is still valid');
    return false;
  } catch (err) {
    console.log('Token verification failed with error:', err?.response?.status);
    if (err?.response?.status === 401){
      console.log('Token is expired (401 from /auth/me)');
      return true
    } 
  }
  console.log('Token verification completed, returning false');
  return false
}
  */


function atualizarPaginaParaForcarNovoLogin(){
  console.log('atualizarPaginaParaForcarNovoLogin called');
  var forcouNovoLogin = sessionStorage.getItem('forcouNovoLogin') || '';
  console.log('forcouNovoLogin sessionStorage value:', forcouNovoLogin);
  if (forcouNovoLogin !== 'YES') { 
      sessionStorage.setItem('forcouNovoLogin','YES');
      
      // Mostrar mensaje más elegante en portugués
      const mensagem = "Sua conta expirou ou é inválida. Por favor, faça login novamente para continuar.";
      alert(mensagem + "\n\nClique em 'OK' para fazer login novamente.");
      
      // Limpiar el token del localStorage para forzar nuevo login
      localStorage.removeItem('token');
      // Redirigir a la página de login
      window.location.href = '/login';
        /*Recarregar a página após a expiração do token irá forçar um novo login, 
        (além de preservar a URL original e retornar o usuário para ela após o processo de login)*/ 
  } else {
    console.log('Login already forced, skipping...');
  }
}


function encontrarMensagemDeErro(err){
  const mensagemDeErro = 
    err?.response?.data?.message 
    || err?.response?.data?.sqlMessage 
    || err?.message 
    || err?.sqlMessage 
    || "ERRO: Erro não identificado"
  return mensagemDeErro;
}



export {
  attachTokenToHeaders,
  encontrarMensagemDeErro,
  handleErrorForAllActions,
  mapApiData,
  mapApiDataArray
}